export const quotations = {
  title: 'Quotations',
  new: 'New Quotation',
  export: 'Export',
  noOffer: 'No quotations',
  shared: 'Link copied to clipboard!',
  selected: 'selected',
  bulkDelete: 'Bulk Delete',
  bulkDeleteTitle: 'Delete Quotations',
  bulkDeleteMessage: 'Are you sure you want to delete {{count}} selected quotations?',
  bulkDeleteWarning: 'This action cannot be undone and will delete all selected quotations.',
  preview: {
    status: 'Status',
    validUntil: 'Valid until',
    subtotal: 'Subtotal',
    totalWithVat: 'Total with VAT',
    product: 'Product',
    quantity: 'Quantity',
    unitPrice: 'Unit price',
    vat: 'VAT',
    total: 'Total',
    downloadPdf: 'Download PDF',
    created: 'Created'
  },
  duplicate: 'Duplicate',
  fields: {
    number: 'ID',
    organization: 'Organization',
    customer: 'Customer',
    status: 'Status',
    total: 'Total',
    validUntil: 'Valid',
    actions: 'Actions',
    items: 'Items',
    subtotal: 'Subtotal',
    tax: 'VAT',
    grandTotal: 'Total',
    viewCount: 'View count',
  },
  status: {
    draft: 'Draft',
    editing: 'Editing',
    pending: 'Pending',
    rejected: 'Rejected',
    success: 'Success'
  },
  filter: {
    allStatuses: 'All statuses',
    allOrgs: 'All organizations'
  },
  tooltips: {
    edit: 'Edit',
    delete: 'Delete',
    preview: 'Preview',
    duplicate: 'Duplicate',
    download: 'Download PDF',
    share: 'Share',
    export: 'Export',
    viewDetails: 'View details',
    generateDocument: 'Generate document',
    viewDocuments: 'View documents',
    createContract: 'Create contract from quotation',
  },
  viewCount: '{{count}} views',
  shareModal: {
    title: 'Share document',
    noDocuments: 'No documents available',
    fileViewer: 'Click to open file',
    open: 'Open',
    openFile: 'Open file',
    linkCreated: 'Link created',
    lastViewed: 'Last viewed',
    passwordProtection: 'Password protection',
    password: 'Password',
    validUntil: 'Valid',
    updateLink: 'Update link',
    createLink: 'Create link',
  },
  messages: {
    confirmTitle: 'Delete Quotation',
    deleteQuestion: 'Are you sure you want to delete this quotation?',
    deleteWarning: 'This action cannot be undone.',
    deleted: 'Quotation successfully deleted',
    deleteError: 'Error occurred while deleting quotation',
    bulkDeleted: '{{count}} quotations successfully deleted',
    downloadError: 'Error occurred while downloading PDF',
    noDocuments: 'No uploaded documents'
  },
  noData: 'No quotations',
  form: {
    basicDetails: {
      title: 'Quotation data',
    },
    title: {
      new: 'Create new quotation',
      edit: 'Edit quotation'
    },
    sections: {
      basic: 'Basic information',
      items: {
        title: 'Items'
      },
      summary: 'Summary',
      companyDetails: {
        title: 'Company data',
        quotationNumber: 'Quotation number',
        companyName: 'Company name',
        companyAddress: 'Company address',
        taxNumber: 'Company tax number',
        registrationNumber: 'Company registration number',
      },
      contactAndPricing: {
        title: 'Contact and pricing',
        contactName: 'Contact name',
        date: 'Date',
        paymentDue: 'Payment term (days)',
        priceUnit: 'Quotation price HUF/kWh-EUR/MWh',
        validUntil: 'Quotation validity',
        price: 'Quotation price',
        paymentDuePlaceholder: 'Enter payment term in days',
      },
      consumptionAndContract: {
        title: 'Consumption and contract',
        consumption: 'Consumption kWh',
        contractStart: 'Contract start',
        contractEnd: 'Contract end',
        estimatedCost: 'Estimated electricity cost',
        price: "Quotation price",
        estimatedAllCost: 'Estimated total cost',
        noData: 'Missing data to calculate the electricity cost.',
      },
      kat: {
        title: 'KÁT',
        text: 'KÁT text',
      },
      pod: {
        title: 'POD',
        podId: 'POD ',
        podAddress: 'Fogy.hely address',
        measurementType: 'Distance / Profile',
        power: 'Power (kW)',
        profileNumber: 'Profile number',
        annualConsumption: 'MÉF / Annual consumption (kWh)',
      },
      additionalPods: {
        title: 'Additional PODs',
        podId: 'POD {{index}}',
        podAddress: 'Fogy.hely address {{index}}',
        measurementType: 'Distance / Profile {{index}}',
        power: 'Power (kW) {{index}}',
        profileNumber: 'Profile number {{index}}',
        annualConsumption: 'MÉF {{index}} / Annual consumption (kWh)',
      },
      documents: {
        title: 'Documents',
        typeContract: 'Contract',
        typeQuotation: 'Quotation',
        typeOther: 'Other',
      }
    },
    fields: {
      organization: 'Organization',
      customer: 'Customer',
      validUntil: 'Valid',
      status: 'Status',
      product: 'Product',
      quantity: 'Quantity',
      price: 'Unit price',
      tax: '% VAT',
      total: 'Total',
      notes: 'Notes',
      contactPerson: 'Contact person',
      itemNotes: 'Item notes',
      quotationNotes: 'Quotation notes',
      listPrice: 'List price'
    },
    buttons: {
      addItem: 'Add item',
      removeItem: 'Remove item',
      createOffer: 'Create quotation',
      updateOffer: 'Update quotation',
      cancel: 'Cancel',
      uploadDocument: 'Upload document',
      viewDocument: 'View',
      deleteDocument: 'Delete',
      createNewCustomer: 'Create new customer'
    },
    messages: {
      noDocuments: 'No documents uploaded'
    },
    validation: {
      organizationRequired: 'Organization is required',
      customerRequired: 'Customer is required',
      validUntilRequired: 'Valid until is required',
      productRequired: 'Product is required',
      quantityRequired: 'Quantity is required',
      priceRequired: 'Price is required',
      taxRequired: 'VAT rate is required',
      itemsRequired: 'At least one item is required'
    },
    newCustomer: {
      individualDescription: 'Create an individual customer with simplified data. Additional data can be provided later.',
      organizationDescription: 'Create an organization with simplified data. Additional data can be provided later.',
      inDevelopmentNote: 'This feature is currently under development. Please use the Customers menu to create a new customer.'
    }
  },
  quotation: 'Quotation',
  generateQuotation: 'Generate quotation document',
  generateContract: 'Generate contract document',
}